export const ru = {
  'addme-button-text': 'Добавить себя',
  'add-participants-from-event-button-text': 'Добавить участников из встречи',
};
